// extracted by mini-css-extract-plugin
module.exports = {"QuickNavAnchors":"QuickNavAnchors-module--QuickNavAnchors--1DeVN","isTop":"QuickNavAnchors-module--isTop--3gxWQ","isSelected":"QuickNavAnchors-module--isSelected--2GlB5"};